module.exports = __webpack_public_path__ + "img/delete_icon.85c744f3.svg";